<template>
  <div class="order_index">
    <el-container>
      <el-aside v-if="user.userType != '00'" style="width: 215px;overflow: hidden;" v-show="showAside">
        <ul class="left_url_tab">
          <el-menu
            v-if="showMenu"
            :default-openeds="openeds"
            :collapse="false"
            default-active="2"
          >
            <el-submenu
              :index="menu.name"
              v-for="(menu, count) in leftMenu"
              :key="count"
            >
              <template slot="title">
                <span style="font-weight:bold;">{{ menu.meta.title }}</span>
              </template>
              <el-menu-item-group>
                <el-menu-item
                  style="padding-left: 48px;"
                  @click.native="
                    jumpPage(resolvePath(topPath, menu.path, child.path))
                  "
                  :index="menu.name + '-' + child.name"
                  v-for="(child, index) in menu.children"
                  :key="index"
                  v-show="!child.hidden"
                >
                  {{ child.meta.title }}</el-menu-item
                >
              </el-menu-item-group>
            </el-submenu>
          </el-menu>
          <OnlineMenu v-else></OnlineMenu>
        </ul>
        <!--商品滚动播放-->
        <Broadcast></Broadcast>
      </el-aside>
      <el-main class="child-content">
        <router-view> </router-view>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import path from "path"
import { mapGetters } from "vuex"
export default {
  name: "orderIndex",
  components: {},
  data() {
    return {
      topPath: "",
      openeds: [],
      showMenu: true,
      showAside: true,
      hideAsideList: [
        "/custom/myOrder/shopCart",
        "/order/myOrder/settlement",
        "/order/myOrder/getPay",
      ],
    }
  },
  watch: {
    $route(to, from) {
      if (
        to.path === "/select/custom/list" ||
        to.path === "/custom/normal/single"
      ) {
        this.showMenu = false
      } else {
        this.showMenu = true
      }
      if (this.hideAsideList.includes(to.path)) {
        this.showAside = false
      } else {
        this.showAside = true
      }
    },
  },
  computed: {
    ...mapGetters(["permission_routes", "user"]),
    leftMenu() {
      if (this.permission_routes[0] && this.permission_routes[0].children) {
        let menus = this.permission_routes[0].children
        let matched = this.$route.matched.filter(
          (item) => item.meta && item.meta.title
        )
        let munuList = matched.filter(
          (item) =>
            item.meta && item.meta.title && item.meta.breadcrumb !== false
        )
        let order = menus.filter((item) => item.path == munuList[0].path)
        this.topPath = order[0].path
        for (let menu of order[0].children) {
          this.openeds.push(menu.name)
        }
        return order[0].children
      }
    },
  },
  created() {},
  methods: {
    title2Click(e, url) {
      let _dom = document.querySelector(".li-title_2.title-2-select")
      if (_dom) {
        _dom.classList.toggle("title-2-select") //当class为project的元素上没有这个CSS类时，它就新增这个CSS类；如果class为project的元素有了这个CSS类，它就是删除它。就是反转操作。
      }
      e.target.classList.toggle("title-2-select")
      this.$router.push(url)
    },
    jumpPage(url) {
      this.$router.push(url)
    },
    resolvePath(firstPath, secondPath, thirdPath) {
      return path.resolve(firstPath, secondPath, thirdPath)
    },
  },
  mounted() {
    if (
      this.$route.path === "/select/custom/list" ||
      this.$route.path === "/custom/normal/single"
    ) {
      this.showMenu = false
    } else {
      this.showMenu = true
    }
    if (this.hideAsideList.includes(this.$route.path)) {
      this.showAside = false
    }
  },
}
</script>

<style scoped>
@import "../../assets/css/sysSup.css";
.order_index {
  width: 100%;
}
.left_url_tab {
}
.left_url_tab li:not(:last-child) {
  list-style: none;
}

.li-title_1 {
  height: 32px;
  line-height: 32px;
  background-color: #c1c1c154;
  vertical-align: top;
  padding-left: 5px;
  font-weight: 600;
}
.li-title_2 {
  height: 28px;
  line-height: 28px;
  vertical-align: top;
  padding-left: 20px;
}
.li-title_3 {
  height: 28px;
  line-height: 28px;
  vertical-align: top;
  padding-left: 40px;
}
.li-title_2:hover,
.li-title_3:hover {
  background-color: #4934b2;
  color: white;
  cursor: pointer;
}
.title-2-select {
  background-color: #4934b2;
  color: white;
  cursor: pointer;
}
.li-help {
  height: 28px;
  line-height: 28px;
  vertical-align: top;
  text-align: center;
  font-size: 16px;
}
.li-help a {
  text-decoration: none;
  color: #4934b2;
}

.el-main {
  overflow: hidden !important;
}
</style>
